var offersCardJuice = document.querySelector('.offers-card-juice')
var offersCardPowder = document.querySelector('.offers-card-powder')
var juiceOption = document.querySelector('#juice-option')
var powderOption = document.querySelector('#powder-option')
var juiceImg = document.querySelector('.juice-img')
var juiceSubscribeImg = document.querySelector('.juice-subscribe-img')
var powderImg = document.querySelector('.powder-img')
// var powderSubscribeImg = document.querySelector('.powder-subscribe-img')
var juiceImgMobile = document.querySelector('.juice-img-mobile')
var juiceSubscribeImgMobile = document.querySelector('.juice-subscribe-img-mobile')
var powderImgMobile = document.querySelector('.powder-img-mobile')

var nextButton = document.querySelector('.next-button')
var firstChoicesDiv = document.querySelector('.offers-content-choices-div')
var secondChoicesDivJuice = document.querySelector('.offers-content-second-choices-div-juice')
var secondChoicesDivPowder = document.querySelector('.offers-content-second-choices-div-powder')

var offersCardJuiceSubscribe = document.querySelector('.offers-card-subscribe-juice')
var offersCardJuiceOneTime = document.querySelector('.offers-card-one-time-juice')
var offersCardPowderSubscribe = document.querySelector('.offers-card-subscribe-powder')
var offersCardPowderOneTime = document.querySelector('.offers-card-one-time-powder')
var juiceOptionSubscribe = document.querySelector('#subscribe-option-juice')
var juiceOptionOneTime = document.querySelector('#one-time-option-juice')
var powderOptionSubscribe = document.querySelector('#subscribe-option-powder')
var powderOptionOneTime = document.querySelector('#one-time-option-powder')

var checkoutButtonJuice = document.querySelector('.checkout-button-juice')
var checkoutButtonPowder = document.querySelector('.checkout-button-powder')

var checkoutButtonDivPowderSubscribe = document.querySelector('.checkout-button-div-powder-subscribe')
var checkoutButtonDivPowderOnce = document.querySelector('.checkout-button-div-powder-once')

var checkoutButtonDivJuiceSubscribe = document.querySelector('.checkout-button-div-juice-subscribe')
var checkoutButtonDivJuiceOnce = document.querySelector('.checkout-button-div-juice-once')

var backButtonSpanOne = document.querySelector('.back-button-span-one')
var backButtonSpanTwo = document.querySelector('.back-button-span-two')

var progressBarHalf = document.querySelector('.progress-bar-div')
var progressBarFull = document.querySelector('.progress-bar-div-full')

var progressBarStepOne = document.querySelector('.progress-step-one')
var progressBarStepTwo = document.querySelector('.progress-step-two')

var shipsEveryFourWeeksDiv = document.querySelector('.ships-every-4-weeks-div')

var chooseYourVersion = document.querySelector('.offers-content-subheader')

var offersCardMobileImgDiv = document.querySelector('.offers-content-mobile-img-div')



function removeContactUsButton(){
  var contactUsIcon = document.querySelector('img[alt="Email Icon"]')

  contactUsIcon.parentElement.style.display = "none"
}

function waitForElement(id, callback){
    var loops = setInterval(function(){
      // console.log("waiting for contact us button")
        if(document.querySelector(id)){
            clearInterval(loops);
            callback();
        }
    }, 100);
}

waitForElement('img[alt="Email Icon"]',removeContactUsButton);


// initial click of juice
offersCardJuice.addEventListener('click', function(){
    if(juiceOption.checked = true){
      juiceOption.checked = true
      juiceImg.classList.remove("no-display")
      juiceSubscribeImg.classList.add("no-display")
        powderImg.classList.add("no-display")
      // powderSubscribeImg.classList.add("no-display")
      // powderSubscribeImg.classList.add("no-display")
        powderImgMobile.classList.add("no-display")
        juiceImgMobile.classList.remove("no-display")
      juiceSubscribeImgMobile.classList.add("no-display")
      shipsEveryFourWeeksDiv.classList.add("no-display")
        powderOption.checked = false
        offersCardPowder.classList.add("unselected")
        offersCardJuice.classList.remove("unselected")
        // console.log('offers card juice clicked')
    } else{
        juiceImg.classList.remove("no-display")
      juiceSubscribeImg.classList.add("no-display")
        powderImg.classList.add("no-display")
      // powderSubscribeImg.classList.add("no-display")
      // powderSubscribeImg.classList.add("no-display")
      powderImgMobile.classList.add("no-display")
        juiceImgMobile.classList.remove("no-display")
      juiceSubscribeImgMobile.classList.add("no-display")
      shipsEveryFourWeeksDiv.classList.add("no-display")
        powderOption.checked = false
        offersCardPowder.classList.add("unselected")
        offersCardJuice.classList.remove("unselected")
        // console.log('offers card juice clicked')
    }

    offersCardJuice.classList.add("offers-card-border")
    offersCardPowder.classList.remove("offers-card-border")
  
})

// initial click of powder
offersCardPowder.addEventListener('click', function(){
  if(powderOption.checked = true){
    powderOption.checked = true
    juiceImg.classList.add("no-display")
    juiceSubscribeImg.classList.add("no-display")
    // powderSubscribeImg.classList.add("no-display")
    powderImgMobile.classList.remove("no-display")
        juiceImgMobile.classList.add("no-display")
      juiceSubscribeImgMobile.classList.add("no-display")
    shipsEveryFourWeeksDiv.classList.add("no-display")
    powderImg.classList.remove("no-display")  
      juiceOption.checked = false
      offersCardJuice.classList.add("unselected")
    offersCardPowder.classList.remove("unselected")
    // console.log('offers card powder clicked')
  } else{
    juiceImg.classList.add("no-display")
    juiceSubscribeImg.classList.add("no-display")
    powderImg.classList.remove("no-display")
    // powderSubscribeImg.classList.add("no-display")
    powderImgMobile.classList.remove("no-display")
        juiceImgMobile.classList.add("no-display")
      juiceSubscribeImgMobile.classList.add("no-display")
    shipsEveryFourWeeksDiv.classList.add("no-display")
      juiceOption.checked = false
      offersCardJuice.classList.add("unselected")
    offersCardPowder.classList.remove("unselected")
    // console.log('offers card powder clicked')
  }

  offersCardJuice.classList.remove("offers-card-border")
    offersCardPowder.classList.add("offers-card-border")
})

// moving from first stage to second stage
nextButton.addEventListener('click', function(){
  if(juiceOption.checked == true) {
    firstChoicesDiv.classList.add("no-display")
    secondChoicesDivJuice.classList.remove("no-display") 
    shipsEveryFourWeeksDiv.classList.remove("no-display")
    // shipsEveryFourWeeksDiv.classList.remove("move-left")
    powderImgMobile.classList.add("no-display")
        juiceImgMobile.classList.add("no-display")
      juiceSubscribeImgMobile.classList.remove("no-display")

    // click juice subscribe
    offersCardJuiceSubscribe.click()
  } else {
    firstChoicesDiv.classList.add("no-display")
    secondChoicesDivPowder.classList.remove("no-display")

     // set the proper image
    // powderSubscribeImg.classList.remove("no-display")
    shipsEveryFourWeeksDiv.classList.remove("no-display")
    // shipsEveryFourWeeksDiv.classList.add("move-left")
    powderImg.classList.remove("no-display")
    juiceImg.classList.add("no-display")
    powderImgMobile.classList.remove("no-display")
        juiceImgMobile.classList.add("no-display")
      juiceSubscribeImgMobile.classList.add("no-display")
    
    // click powder subscribe
    offersCardPowderSubscribe.click()
  }
     // console.log('next button clicked')
  backButtonSpanTwo.classList.remove("no-display")
  backButtonSpanOne.classList.add("no-display")

  progressBarFull.classList.remove("no-display")
  progressBarHalf.classList.add("no-display")

  progressBarStepTwo.classList.remove("no-display")
  progressBarStepOne.classList.add("no-display")

  chooseYourVersion.classList.add("no-display")

  offersCardMobileImgDiv.classList.remove("no-display")
})

// when Subscribe to Powder is clicked
offersCardPowderSubscribe.addEventListener('click', function(){
  if(powderOptionSubscribe.checked = true){
    powderOptionSubscribe.checked = true
    // un-check one-time option
    powderOptionOneTime.checked = false
    offersCardPowderSubscribe.classList.remove("unselected")
    offersCardPowderOneTime.classList.add("unselected")
  
    // set the proper checkout link (subscribe option)
    // checkoutButtonPowder.href = "https://120life.myshopify.com/cart/clear?return_to=/cart/add?items[]id=44705672757530%26items[]quantity=1%26items[]selling_plan=8075608346%26return_to=/checkout"
    checkoutButtonDivPowderOnce.classList.add("no-display")
    checkoutButtonDivPowderSubscribe.classList.remove("no-display")
    
    // console.log('offers card powder SUBSCRIBE clicked')

    // set the proper image
    // powderSubscribeImg.classList.remove("no-display")
    // powderImg.classList.add("no-display")
    

    shipsEveryFourWeeksDiv.classList.remove("no-display")
    // shipsEveryFourWeeksDiv.classList.add("move-left")
  } else{
    // un-check one-time option
    powderOptionOneTime.checked = false
      offersCardPowderSubscribe.classList.remove("unselected")
      offersCardPowderOneTime.classList.add("unselected")
    
      // set the proper checkout link (subscribe option)
      // checkoutButtonPowder.href = "https://120life.myshopify.com/cart/clear?return_to=/cart/add?items[]id=44705672757530%26items[]quantity=1%26items[]selling_plan=8075608346%26return_to=/checkout"
    checkoutButtonDivPowderOnce.classList.add("no-display")
    checkoutButtonDivPowderSubscribe.classList.remove("no-display")
    // console.log('offers card powder SUBSCRIBE clicked')

     // set the proper image
    // powderSubscribeImg.classList.remove("no-display")
    // powderImg.classList.add("no-display")

    shipsEveryFourWeeksDiv.classList.remove("no-display")
    // shipsEveryFourWeeksDiv.classList.add("move-left")
      }
})

// when One Time to Powder is clicked
offersCardPowderOneTime.addEventListener('click', function(){
  if(powderOptionOneTime.checked = true){
    powderOptionOneTime.checked = true
    // un-check one-time option
    powderOptionSubscribe.checked = false
     offersCardPowderSubscribe.classList.add("unselected")
    offersCardPowderOneTime.classList.remove("unselected")
  
    // set the proper checkout link (subscribe option)
    // checkoutButtonPowder.href = "http://120life.myshopify.com/cart/44705672757530:1"
    checkoutButtonDivPowderOnce.classList.remove("no-display")
    checkoutButtonDivPowderSubscribe.classList.add("no-display")
      // console.log('offers card powder ONE TIME clicked')

     // set the proper image
    // powderSubscribeImg.classList.add("no-display")
    // powderImg.classList.remove("no-display")

    shipsEveryFourWeeksDiv.classList.add("no-display")
  } else{
    // un-check one-time option
    powderOptionSubscribe.checked = false
   offersCardPowderSubscribe.classList.add("unselected")
  offersCardPowderOneTime.classList.remove("unselected")

  // set the proper checkout link (subscribe option)
  // checkoutButtonPowder.href = "http://120life.myshopify.com/cart/44705672757530:1"
    checkoutButtonDivPowderOnce.classList.remove("no-display")
    checkoutButtonDivPowderSubscribe.classList.add("no-display")
    // console.log('offers card powder ONE TIME clicked')

     // set the proper image
    // powderSubscribeImg.classList.add("no-display")
    // powderImg.classList.remove("no-display")

    shipsEveryFourWeeksDiv.classList.add("no-display")
  }
})


// when Subscribe to Juice is clicked
offersCardJuiceSubscribe.addEventListener('click', function(){
  if(juiceOptionSubscribe.checked = true){
    juiceOptionSubscribe.checked = true
    // un-check one-time option
    juiceOptionOneTime.checked = false
    offersCardJuiceSubscribe.classList.remove("unselected")
  offersCardJuiceOneTime.classList.add("unselected")

  // set the proper checkout link (subscribe option)
  // checkoutButtonJuice.href = "https://120life.myshopify.com/cart/clear?return_to=/cart/add?items[]id=39646986436692%26items[]quantity=1%26items[]selling_plan=466059348%26return_to=/checkout"
  checkoutButtonDivJuiceOnce.classList.add("no-display")
    checkoutButtonDivJuiceSubscribe.classList.remove("no-display")
    
    // console.log('offers card juice SUBSCRIBE clicked')

    // set the proper image
    juiceSubscribeImg.classList.remove("no-display")
    juiceImg.classList.add("no-display")

        juiceImgMobile.classList.add("no-display")
      juiceSubscribeImgMobile.classList.remove("no-display")

    shipsEveryFourWeeksDiv.classList.remove("no-display")
    // shipsEveryFourWeeksDiv.classList.remove("move-left")
  } else{
    // un-check one-time option
    juiceOptionOneTime.checked = false
    offersCardJuiceSubscribe.classList.remove("unselected")
    offersCardJuiceOneTime.classList.add("unselected")
  
    // set the proper checkout link (subscribe option)
    // checkoutButtonJuice.href = "https://120life.myshopify.com/cart/clear?return_to=/cart/add?items[]id=39646986436692%26items[]quantity=1%26items[]selling_plan=466059348%26return_to=/checkout"
    checkoutButtonDivJuiceOnce.classList.add("no-display")
    checkoutButtonDivJuiceSubscribe.classList.remove("no-display")
    // console.log('offers card juice SUBSCRIBE clicked')

    // set the proper image
    juiceSubscribeImg.classList.remove("no-display")
    juiceImg.classList.add("no-display")

        juiceImgMobile.classList.add("no-display")
      juiceSubscribeImgMobile.classList.remove("no-display")

    shipsEveryFourWeeksDiv.classList.remove("no-display")
    // shipsEveryFourWeeksDiv.classList.remove("move-left")
  }
})

// when One Time to Powder is clicked
offersCardJuiceOneTime.addEventListener('click', function(){
  if(juiceOptionOneTime.checked = true){
    juiceOptionOneTime.checked = true
    // un-check one-time option
    juiceOptionSubscribe.checked = false
   offersCardJuiceSubscribe.classList.add("unselected")
    offersCardJuiceOneTime.classList.remove("unselected")
    // set the proper checkout link (subscribe option)
    // checkoutButtonJuice.href = "http://120life.myshopify.com/cart/39355694841940:1"
    checkoutButtonDivJuiceOnce.classList.remove("no-display")
    checkoutButtonDivJuiceSubscribe.classList.add("no-display")
      // console.log('offers card juice ONE TIME clicked')

    // set the proper image
    juiceSubscribeImg.classList.add("no-display")
    juiceImg.classList.remove("no-display")

        juiceImgMobile.classList.remove("no-display")
      juiceSubscribeImgMobile.classList.add("no-display")

    shipsEveryFourWeeksDiv.classList.add("no-display")
  } else{
    // un-check one-time option
    juiceOptionSubscribe.checked = false
     offersCardJuiceSubscribe.classList.add("unselected")
      offersCardJuiceOneTime.classList.remove("unselected")
      // set the proper checkout link (subscribe option)
      // checkoutButtonJuice.href = "http://120life.myshopify.com/cart/39355694841940:1"
    checkoutButtonDivJuiceOnce.classList.remove("no-display")
    checkoutButtonDivJuiceSubscribe.classList.add("no-display")
        // console.log('offers card juice ONE TIME clicked')

    // set the proper image
    juiceSubscribeImg.classList.add("no-display")
    juiceImg.classList.remove("no-display")

        juiceImgMobile.classList.remove("no-display")
      juiceSubscribeImgMobile.classList.add("no-display")

    shipsEveryFourWeeksDiv.classList.add("no-display")
  }
})

backButtonSpanOne.addEventListener('click', function(){
  window.location.href = "https://www.120life.com/products/120-life-free-shipping"
  
})

backButtonSpanTwo.addEventListener('click', function(){
  secondChoicesDivJuice.classList.add("no-display") 
secondChoicesDivPowder.classList.add("no-display")
  firstChoicesDiv.classList.remove("no-display")
  backButtonSpanTwo.classList.add("no-display")
  backButtonSpanOne.classList.remove("no-display")

  progressBarFull.classList.add("no-display")
  progressBarHalf.classList.remove("no-display")

  progressBarStepTwo.classList.add("no-display")
  progressBarStepOne.classList.remove("no-display")

  shipsEveryFourWeeksDiv.classList.add("no-display")

  chooseYourVersion.classList.remove("no-display")

  offersCardMobileImgDiv.classList.add("no-display")
})



// reset to be juice and subscribe
offersCardJuice.click()
// console.log("should have clicked juice")
offersCardPowder.click()
// console.log("should have clicked powder")



offersCardPowder.classList.remove("unselected")
offersCardJuice.classList.add("unselected")
    
juiceOption.checked = false
powderOption.checked = true


// add discount code functionality
function getCookie(name) { 
 var re = new RegExp(name + "=([^;]+)"); 
 var value = re.exec(document.cookie); 
 return (value != null) ? unescape(value[1]) : null; 
}

//Call the function
// console.log('cookie discount incoming')
// console.log(getCookie('discount_code_bp'));

// update all Checkout buttons with this discount code
// if(getCookie('code_bp')!=null){
if(localStorage.getItem("code_bp")!=null){

  
  var checkoutButtonJuiceSubscribe = document.querySelector('.checkout-button-juice-subscribe')
  // checkoutButtonJuiceSubscribe.href = checkoutButtonJuiceSubscribe.href + '?discount=' + getCookie('code_bp')
  checkoutButtonJuiceSubscribe.href = checkoutButtonJuiceSubscribe.href + '?discount=' + localStorage.getItem("code_bp")
  
  
  var checkoutButtonJuiceTrial = document.querySelector('.checkout-button-juice-once')
  // console.log("href incoming")
  // console.log(checkoutButtonJuiceTrial.href)
  // checkoutButtonJuiceTrial.href = checkoutButtonJuiceTrial.href + '?discount=' + getCookie('code_bp')
  checkoutButtonJuiceTrial.href = checkoutButtonJuiceTrial.href + '?discount=' + localStorage.getItem("code_bp")
  // console.log(checkoutButtonJuiceTrial.href)

  var checkoutButtonPowderSubscribe = document.querySelector('.checkout-button-powder-subscribe')
  // checkoutButtonPowderSubscribe.href = checkoutButtonPowderSubscribe.href + '?discount=' + getCookie('code_bp')
  checkoutButtonPowderSubscribe.href = checkoutButtonPowderSubscribe.href + '?discount=' + localStorage.getItem("code_bp")

  var checkoutButtonPowderTrial = document.querySelector('.checkout-button-powder-once')
  // checkoutButtonPowderTrial.href = checkoutButtonPowderTrial.href + '?discount=' + getCookie('code_bp')
  checkoutButtonPowderTrial.href = checkoutButtonPowderTrial.href + '?discount=' + localStorage.getItem("code_bp")
}


Array.from(document.querySelectorAll(".checkout-button")).forEach(button =>  button.addEventListener("click", function(e) {
   
  //fire Meta pixel here
  try {
    e.preventDefault();
    const offersSection = document.querySelector(".offers-section");
    const juiceSubscribePrice = offersSection.dataset.juiceSubscribePrice;
    const juiceSinglePrice = offersSection.dataset.juiceSinglePrice;
    const powderSubscribePrice = offersSection.dataset.powderSubscribePrice;
    const powderSinglePrice = offersSection.dataset.powderSinglePrice;
    const juiceProduct = JSON.parse(offersSection.dataset.juiceProduct);
    const powderProduct = JSON.parse(offersSection.dataset.powderProduct);
    
    //based on classlist get value
    let chosenProduct;
    let chosenPrice;
    const checkoutClasses = this.classList.toString();
    if (checkoutClasses.includes("juice")) {
      chosenProduct = juiceProduct;
      productID = juiceProduct.id;
      if(checkoutClasses.includes("once")) {
        chosenPrice = juiceSinglePrice;
      } else {
        chosenPrice = juiceSubscribePrice;
      }
    } else {
      chosenProduct = powderProduct;
      if(checkoutClasses.includes("once")) {
        chosenPrice = powderSinglePrice;
      } else {
        chosenPrice = powderSubscribePrice;
      }
    }
  
    //get chosen values for info
    fbq('track', 'AddToCart', {
      content_name: chosenProduct.title,
      content_category: chosenProduct.type,
      currency: "USD",
      value: chosenPrice,
      content_ids: [`${chosenProduct.id}`],
      num_items: 1
    })
    window.location = this.href;
  } catch (error) {
    window.location = this.href;
  }

  
  
}))